import { Component, Input } from '@angular/core';
import { ClassificationService } from '../../../../services/classification.service';
import { ClassificationConfiguration } from '../../../../model/classification-configuration';
import { ClassificationWeight } from '../../../../model/classification-weight';
import { ClassificationExpectation } from '../../../../model/classification-expectation';
import { LoadingController } from 'ionic-angular';

@Component({
    selector: 'admin-classification-configuration',
    templateUrl: 'configuration.html'
})
export class ClassificationConfigurationSection {
    @Input('viewMode') viewMode: string;
    @Input('disciplines') disciplines: string[];
    @Input('configurations') configurations: ClassificationConfiguration[];

    selectedConfiguration: ClassificationConfiguration = new ClassificationConfiguration();
    selectedRole: string = 'All';
    selectedMode: string = 'Weights';

    selectedWeights: ClassificationWeight[] = [];
    selectedExpectations: ClassificationExpectation[] = [];

    selectedDiscipline: string = 'All';

    constructor(public classificationService: ClassificationService, public loadingCtrl: LoadingController) {

    }

    onDisciplineChange() {
        this.selectedConfiguration = this.configurations.filter(x => x.eventType == this.selectedDiscipline)[0];

        if (!this.selectedConfiguration) {
            this.selectedConfiguration = new ClassificationConfiguration();
            this.selectedConfiguration.weights = [];
            this.selectedConfiguration.weights.push(new ClassificationWeight(true, false));
            this.selectedConfiguration.weights.push(new ClassificationWeight(true, true));

            this.selectedConfiguration.expectations = [];
            this.selectedConfiguration.expectations.push(new ClassificationExpectation(true, false));
            this.selectedConfiguration.expectations.push(new ClassificationExpectation(true, true));

            this.configurations.push(this.selectedConfiguration)
        }

        if (this.selectedDiscipline == 'TeamRoping' || this.selectedDiscipline == 'All') {
            if (!this.selectedConfiguration.weights.some(x => !x.positionOne && !x.horse)) {
                this.selectedConfiguration.weights.push(new ClassificationWeight(false, false));
                this.selectedConfiguration.expectations.push(new ClassificationExpectation(false, false));
            }

            if (!this.selectedConfiguration.weights.some(x => !x.positionOne && x.horse)) {
                this.selectedConfiguration.weights.push(new ClassificationWeight(false, true));
                this.selectedConfiguration.expectations.push(new ClassificationExpectation(false, true));
            }
        }
    }

    onSelectedRoleChange() {
        if (this.selectedRole == 'Contestant One') {
            this.selectedWeights = this.selectedConfiguration.weights.filter(x => x.positionOne && !x.horse);
            this.selectedExpectations = this.selectedConfiguration.expectations.filter(x => x.positionOne && !x.horse);
        } else if (this.selectedRole == 'Contestant Two') {
            this.selectedWeights = this.selectedConfiguration.weights.filter(x => !x.positionOne && !x.horse);
            this.selectedExpectations = this.selectedConfiguration.expectations.filter(x => !x.positionOne && !x.horse);
        } else if (this.selectedRole == 'Horse One') {
            this.selectedWeights = this.selectedConfiguration.weights.filter(x => x.positionOne && x.horse);
            this.selectedExpectations = this.selectedConfiguration.expectations.filter(x => x.positionOne && x.horse);
        } else if (this.selectedRole == 'Horse Two') {
            this.selectedWeights = this.selectedConfiguration.weights.filter(x => !x.positionOne && x.horse);
            this.selectedExpectations = this.selectedConfiguration.expectations.filter(x => !x.positionOne && x.horse);
        } else {
            this.selectedWeights = this.selectedConfiguration.weights;
            this.selectedExpectations = this.selectedConfiguration.expectations;
        }
    }

    saveConfiguration() {
        let loader = this.loadingCtrl.create({
            content: "Saving configuration..."
        });
        loader.present();

        this.classificationService.saveConfiguration(this.selectedConfiguration)
            .then(data => {
                this.selectedConfiguration = data as ClassificationConfiguration;
                loader.dismiss();
            })
            .catch((err) => {
                console.error(err);
                loader.dismiss();
            })
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/admin/classification/configuration.ts